import {
    AgentUsageView,
    AgentUsageViewSchema,
} from "@common/types/views/agentUsageView";
import { createDefaultAgentUsageView } from "@components/agentUsage/DefaultAgentUsageView";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

export function useAgentUsageViewStore() {
    return useViewStore<AgentUsageView>({
        defaultView: createDefaultAgentUsageView(),
        viewSchema: AgentUsageViewSchema,
        cacheKey: ORGANIZATION_USER_CACHE_KEYS.AGENT_USAGE_PAGE_VIEW_CACHE_KEY,
    });
}
